import cls from './ButtonLike.module.scss';
import { ButtonHTMLAttributes, FC } from "react";
import { classNames } from "../../lib/className/className";
import { ReactComponent as HeartIcon } from '../../../assets/icons/heart.svg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
}

export const ButtonLike: FC<ButtonProps> = ({ className, ...otherProps }) => {
    return (
        <button
            className={classNames(cls.button, {}, className ? [className] : [])}
            {...otherProps}
        >
            <HeartIcon />
        </button>
    );
};
